import { Component } from 'react';
import { observer } from 'mobx-react';
import { Field, Form, FormGroup, Radio, RadioGroup } from '@availity/form';
import '@availity/yup';
import { Button, Col, Row } from 'reactstrap';
import * as yup from 'yup';
import PropTypes from 'prop-types';
import { DateField } from '@availity/date';
import moment from 'moment';

import withNavigate from '../../Common/components/withNavigate';
import ReimbursementStore from '../stores';
import CustomProgressBar from '../CustomProgressBar/CustomProgressBar';


@observer
class MovingAttestation extends Component {

    componentDidMount() {
        if (window.performance) {
            if (performance.navigation.type == 1) {
                const contextPath = window.location.pathname;
                window.location.href = contextPath;
            }
        }
        
        // keep the user on the same page on browser back button/arrow click
        window.onpopstate = () => {
            this.props.navigate(1);
        }
    }

    enableHousingTransition = value => {
        ReimbursementStore.setAttestRadio(value);
        if (value === "Provider Attest") {
            ReimbursementStore.setDefaultProviderAttFields();
        } else {
            ReimbursementStore.setDefaultEnrolleAttFields();
        }

    }

    setProviderAttestInfo = event => {
        const { name, value } = event.target;
        ReimbursementStore.setProviderAttestInfo(name, value);
    }

    setEnrolleAttestInfo = event => {
        const { name, value } = event.target;
        ReimbursementStore.setEnrolleAttestInfo(name, value);
    }

    setProviderConsentDate = (value) => {
        ReimbursementStore.setProviderAttestInfo("consentDate", value);
    }

    setEnrolleConsentDate = (value) => {
        ReimbursementStore.setEnrolleAttestInfo("consentDate", value);
    }

    setEnrolleConsentTime = (event) => {
        const { value } = event.target;
        ReimbursementStore.setEnrolleAttestInfo("consentTime", value);
    }

    submit = () => {
        const { navigate } = this.props;
        ReimbursementStore.setReimbursementPageStatus("#movingattestation", 'complete');
        navigate('/documentation');
    }

    back = () => {
        const { navigate } = this.props;
        navigate('/expendituresinfo');
    }

    render() {

        const {
            providerAttestInfo,
            enrolleAttestInfo,
            attestRadio,
            reimbursementFormPages
        } = ReimbursementStore

        return (
            <>
                <div className="border-form">

                    <Form
                        onSubmit={this.submit}
                        enableReinitialize
                        initialValues={{
                            provAttFirstName: providerAttestInfo.provAttFirstName,
                            provAttLastName: providerAttestInfo.provAttLastName,
                            enrolleFirstName: enrolleAttestInfo.enrolleFirstName,
                            enrolleLastName: enrolleAttestInfo.enrolleLastName,
                            providerConsentDateField: providerAttestInfo.consentDate,
                            enrolleConsentDateField: enrolleAttestInfo.consentDate,
                            enrolleConsentTimeField: enrolleAttestInfo.consentTime,
                            movingAttestationRadioField: attestRadio,

                        }}
                        validationSchema={yup.object().shape({
                            movingAttestationRadioField: yup.string().required("Required"),
                            provAttFirstName:
                                attestRadio === "Provider Attest" ?
                                    yup
                                        .string()
                                        .required('First Name is required')
                                    :
                                    yup
                                        .string(),
                            provAttLastName:
                                attestRadio === "Provider Attest" ?
                                    yup
                                        .string()
                                        .required('Last Name is required')
                                    :
                                    yup
                                        .string(),
                            providerConsentDateField:
                                attestRadio === "Provider Attest" ?
                                    yup.date()
                                        .max(moment().format('MM/DD/YYYY'), 'Date cannot be in the future')
                                        .min(moment().subtract(8, 'days').format('MM/DD/YYYY'))
                                        .required('Consent Date is required')
                                        .typeError('Invalid Date')
                                    :
                                    yup.date(),
                            enrolleFirstName:
                                attestRadio === "Enrollee Attest" ?
                                    yup
                                        .string()
                                        .required('First Name is required')
                                    :
                                    yup
                                        .string(),
                            enrolleLastName:
                                attestRadio === "Enrollee Attest" ?
                                    yup
                                        .string()
                                        .required('Last Name is required')
                                    :
                                    yup
                                        .string(),
                            enrolleConsentDateField:
                                attestRadio === "Enrollee Attest" ?
                                    yup.date()
                                        .max(moment().format('MM/DD/YYYY'), 'Date cannot be in the future')
                                        .min(moment().subtract(8, 'days').format('MM/DD/YYYY'))
                                        .required('Consent Date is required')
                                        .typeError('Invalid Date')
                                    :
                                    yup.date(),
                            enrolleConsentTimeField:
                                attestRadio === "Enrollee Attest" ?
                                    yup.string().required('Time Consent is required')
                                    :
                                    yup.string()
                        })}
                    >
                        <CustomProgressBar pages={reimbursementFormPages} page="#movingattestation" />
                        <div>
                            <small className="required-fields">*required</small>
                            <div className="spacer-48" />
                            <h2 className="poppinsH2" id="fcs-tap-heading">
                                Moving Attestation
                            </h2>
                        </div>
                        <div className="spacer-24" />
                        <div>

                            <p>
                                Enrollees interested in utilizing FCS TAP funds must be making a housing transition, in addition to meeting other TAP eligibility criteria listed in the
                                <a
                                    target="_blank"
                                    rel="noreferrer"
                                    href='https://www.provider.wellpoint.com/docs/gpp/WAWA_WLP_CAID_FCS_QuickReferenceGuide.pdf?v=202406202115'>
                                    &nbsp;FCS TAP Quick Reference Guide.
                                </a>
                            </p>
                        </div>
                        <div className="spacer-24" />
                        <div>
                            <strong>
                                I have determined the enrollee is moving to new housing by one of the following:
                            </strong>
                        </div>
                        <div className="spacer-24" />

                        <RadioGroup name='movingAttestationRadioField' value={attestRadio} onChange={this.enableHousingTransition}>
                            <Radio
                                className='repeat-radio'
                                label="I, the provider, attest that the following enrollee is making a housing transition."
                                value="Provider Attest" />
                            <div className="spacer-24" />

                            {
                                attestRadio === "Provider Attest" &&
                                <>
                                    <Row>
                                        <Col sm='6'>
                                            <FormGroup for='provAttFirstName'>
                                                <Field
                                                    type='text'
                                                    name='provAttFirstName'
                                                    label='First Name*'
                                                    value={providerAttestInfo.provAttFirstName}
                                                    onChange={this.setProviderAttestInfo}
                                                    maxLength={50}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col sm='6'>
                                            <FormGroup for='provAttLastName'>
                                                <Field
                                                    type='text'
                                                    name='provAttLastName'
                                                    label='Last Name*'
                                                    value={providerAttestInfo.provAttLastName}
                                                    onChange={this.setProviderAttestInfo}
                                                    maxLength={50}
                                                />

                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm='3'>
                                            <FormGroup for='consentDate'>
                                                <DateField
                                                    label='Date Consent Received*'
                                                    name='providerConsentDateField'
                                                    value={providerAttestInfo.consentDate}
                                                    onChange={this.setProviderConsentDate}
                                                    datePickerProps={{ openDirection: 'up', showDefaultInputIcon: true, inputIconPosition: 'after' }}
                                                    min={{ value: 8, units: 'day' }}
                                                    max={{ value: 0, units: 'day' }}
                                                    defaultValue={null}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </>
                            }

                            <div className="spacer-24" />
                            <Radio
                                className='repeat-radio'
                                label="I, the enrollee, attest that I am making a housing transition."
                                value="Enrollee Attest" />

                            {
                                attestRadio === "Enrollee Attest" &&
                                <>
                                    <Row>
                                        <Col sm='6'>
                                            <FormGroup for='enrolleFirstName'>
                                                <Field
                                                    type='text'
                                                    name='enrolleFirstName'
                                                    label='First Name*'
                                                    value={enrolleAttestInfo.enrolleFirstName}
                                                    onChange={this.setEnrolleAttestInfo}
                                                    maxLength={50}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col sm='6'>
                                            <FormGroup for='enrolleLastName'>
                                                <Field
                                                    type='text'
                                                    name='enrolleLastName'
                                                    label='Last Name*'
                                                    value={enrolleAttestInfo.enrolleLastName}
                                                    onChange={this.setEnrolleAttestInfo}
                                                    maxLength={50}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm='3'>
                                            <FormGroup for='consentDate'>
                                                <FormGroup for='consentDate'>
                                                    <DateField
                                                        label='Date Consent Received*'
                                                        name='enrolleConsentDateField'
                                                        value={enrolleAttestInfo.consentDate}
                                                        onChange={this.setEnrolleConsentDate}
                                                        datePickerProps={{ openDirection: 'up', showDefaultInputIcon: true, inputIconPosition: 'after' }}
                                                        min={{ value: 8, units: 'day' }}
                                                        max={{ value: 0, units: 'day' }}
                                                        defaultValue={null}
                                                    />
                                                </FormGroup>
                                            </FormGroup>
                                        </Col>
                                        <Col sm='6'>
                                            <FormGroup for='enrolleConsentTimeField'>
                                                <Field
                                                    type="time"
                                                    label='Time Consent Received*'
                                                    name="enrolleConsentTimeField"
                                                    className="straighten-borders"
                                                    value={enrolleAttestInfo.consentTime}
                                                    onChange={this.setEnrolleConsentTime}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </>
                            }
                        </RadioGroup>

                        <div className="spacer-48" />
                        <Button type="submit" color={"primary"} className={"btn btn-primary nextBtn"}>
                            Next
                        </Button>

                        <Button type="button" color={"primary"} className={'btn btn-primary backButton'} onClick={this.back}>
                            Back
                        </Button>

                        <div className="pb-spacerRem-10" />

                    </Form>
                </div>
            </>
        );
    }
}
export default withNavigate(MovingAttestation);

MovingAttestation.propTypes = {
    navigate: PropTypes.func
};
